export const areAddressesEqual = (addressA: string, addressB: string) =>
  addressA.toLowerCase() === addressB.toLowerCase();

export default areAddressesEqual;
